
import Category from '~/pages/_lang/category/_department/_category/index.vue'

export default Category
